<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [breakpoints]="{ '960px': '90vw', '640px': '100vw' }"
  [style]="{ width: '58rem' }"
  styleClass="add-profile-dialog"
  (onHide)="onHide()"
>
  <form autocomplete="off" class="p-fluid text-sm profile-form" [formGroup]="form">
    <div class="profile-form__field profile-form__field--firstName">
      <label for="firstName">{{ 'ADD_PROFILE.FIRST_NAME' | translate }}*</label>
      <input id="firstName" pInputText formControlName="firstName" />
    </div>

    <div class="profile-form__field profile-form__field--lastName">
      <label for="lastName">{{ 'ADD_PROFILE.LAST_NAME' | translate }}*</label>
      <input id="lastName" pInputText formControlName="lastName" />
    </div>

    <div class="profile-form__field profile-form__field--email">
      <label for="email">{{ 'ADD_PROFILE.EMAIL' | translate }}*</label>
      <input id="email" pInputText formControlName="email" type="email" />
    </div>

    <div class="profile-form__field profile-form__field--linkedin">
      <label for="linkedin">{{ 'ADD_PROFILE.LINKEDIN' | translate }}*</label>
      <input id="linkedin" pInputText formControlName="linkedin" [class.field-error]="submitted && form.controls.linkedin.invalid" />

      <div class="field-tooltip" *ngIf="submitted && form.controls.linkedin.invalid">{{ 'ADD_PROFILE.LINKEDIN_INVALID' | translate }}</div>
    </div>

    <div class="profile-form__field profile-form__field--city">
      <label for="city">{{ 'ADD_PROFILE.CITY' | translate }}*</label>
      <input id="city" pInputText formControlName="city" />
    </div>

    <div class="profile-form__field profile-form__field--jobTitle">
      <label for="jobTitle">{{ 'ADD_PROFILE.JOB_TITLE' | translate }}*</label>
      <input id="jobTitle" pInputText formControlName="jobTitle" />
    </div>

    <div class="profile-form__field profile-form__field--company">
      <label for="company">{{ 'ADD_PROFILE.COMPANY' | translate }}*</label>
      <input id="company" pInputText formControlName="company" />
    </div>

    <div class="profile-form__field profile-form__field--field">
      <label for="field">{{ 'ADD_PROFILE.FIELD' | translate }}*</label>
      <p-select
        inputId="field"
        formControlName="field"
        [options]="fieldOptions"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
      ></p-select>
    </div>

    <div class="profile-form__field profile-form__field--country">
      <label for="country">{{ 'ADD_PROFILE.COUNTRY' | translate }}*</label>
      <p-select
        inputId="country"
        formControlName="country"
        [options]="countryOptions"
        optionLabel="label"
        optionValue="value"
        [filter]="true"
        filterBy="label"
        filterMatchMode="startsWith"
        panelStyleClass="add-profile-dropdown-panel"
        appendTo="body"
      ></p-select>
    </div>

    <div class="profile-form__field profile-form__field--interests">
      <label for="interests">{{ 'ADD_PROFILE.TOP_INTERESTS' | translate }}*</label>
      <p-multiSelect
        inputId="interests"
        formControlName="interests"
        [options]="interestOptions"
        optionLabel="label"
        optionValue="value"
        [selectionLimit]="3"
        [showToggleAll]="false"
        [filter]="false"
        display="chip"
        styleClass="interests-select"
        appendTo="body"
      ></p-multiSelect>
    </div>

    <div class="profile-form__field profile-form__field--photo">
      <div class="photo-panel">
        <p class="photo-panel__title">{{ 'ADD_PROFILE.YOUR_PHOTO' | translate }}</p>

        <div class="photo-panel__circle" (click)="fileInput.click()">
          <img *ngIf="photoPreview" [src]="photoPreview" alt="" />
          <i *ngIf="!photoPreview" class="pi pi-plus"></i>
        </div>

        <input #fileInput type="file" accept="image/*" class="hidden" (change)="onPhotoSelected($event)" />

        <p-button
          styleClass="photo-panel__btn"
          [label]="'ADD_PROFILE.UPLOAD_PHOTO' | translate"
          type="button"
          (onClick)="fileInput.click()"
        ></p-button>
      </div>
    </div>

    <div class="profile-form__consent">
      <p-checkbox formControlName="consent" [binary]="true" inputId="consent"></p-checkbox>
      <label for="consent" class="add-profile-dialog__consent">{{ 'ADD_PROFILE.CONSENT' | translate }}</label>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="add-profile-dialog__footer-inner">
      <div [pTooltip]="form.invalid ? ('ADD_PROFILE.TOOLTIP_DISABLED' | translate) : null" tooltipPosition="top">
        <p-button
          styleClass="p-button-success add-profile-dialog__submit"
          [label]="'ADD_PROFILE.SUBMIT' | translate"
          type="button"
          (onClick)="onSubmit()"
        ></p-button>
      </div>

      <p class="mt-3 add-profile-dialog__note" [innerHTML]="'ADD_PROFILE.CONTACT_NOTE' | translate"></p>
      <p class="add-profile-dialog__note">*{{ 'ADD_PROFILE.REQUIRED_FIELDS' | translate }}</p>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="showSuccessDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [breakpoints]="{ '960px': '90vw', '640px': '100vw' }"
  [style]="{ width: '40rem', minHeight: '26rem' }"
  styleClass="success-dialog"
  (onHide)="closeConfirmingSuccessDialog()"
>
  <div class="success-dialog__content">
    <h2 class="success-dialog__title">{{ 'ADD_PROFILE.SUCCESS.TITLE' | translate }}</h2>
    <p class="success-dialog__message">
      {{ 'ADD_PROFILE.SUCCESS.MESSAGE' | translate }}
      <a href="mailto:help@femmepalette.com">help&#64;femmepalette.com</a>.
    </p>
    <p-button
      styleClass="p-button-warning success-dialog__close"
      [label]="'ADD_PROFILE.SUCCESS.CLOSE' | translate"
      type="button"
      (onClick)="closeConfirmingSuccessDialog()"
    ></p-button>
  </div>
</p-dialog>
